module.exports = __webpack_public_path__ + "static/front-page-06-84ce1356be3c41e036701dee7326380c.jpg";